import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import Link from '../../../../../components/ZUILib/Link';
import commonUtil from '../../../../../utils/commonUtil';
import InputButton from '../../../../../components/ZUILib/InputButton';
import VerificationPanel from './verificationPanel';
import ModalPopover from '../../../../../components/ZUILib/ModalPopover';
import LoginModal from './loginModal';
import Tagging from '../../../../../components/Tagging/Tagging';
import AlertTransferences from './alertTransferences';
import * as typeActions from '../../actions';


const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

const { submitTransference } = typeActions;

class VerificationForm extends Component {

  constructor(props) {
    super(props);
    this.login = this.loginModalRea ? this.loginModalRea.login.getValue() : null;
    this.submitTransfernceDataDetails = '';
    this.submit = null;
    this.confirmationButtonDisable = null;
    this.commissionFee = '';
    this.state = {
      submitTransferenceErrorMessage: null,
    };
  }
  confirmation = () => {
    this.submitTransfernceDataDetails = this.props.submitTransferenceData;
    // Bug 11416 : P1 Blocker : ICD-GR-PROD-UAT-LIV-ALL-C9-For the migrated event is not showing the modal to enter the password and confirm the transfer
    // if (this.props.transferenceData && this.props.transferenceData.migratedEvent && this.props.transferenceData.migratedEvent.toString() === 'true') {
    //   this.callSubmitTransference();
    // } else {
    //   this.loginModal.handleShow();
    // }
    this.props.nextPageWap();
  }
  callSubmitTransference = () => {
    this.submitTransferenceData = Object.assign({}, this.submitTransfernceDataDetails);
    if (this.submitTransferenceData.cardOrBankIdentifierId) {
      this.submitTransferenceData.paymentType = '2';
    }
    delete this.submitTransferenceData.commissionValue;
    delete this.submitTransferenceData.accountNumber;
    delete this.submitTransferenceData.transferDate;
    delete this.submitTransferenceData.cardNumber;
    delete this.submitTransferenceData.userName;
    this.props.submitTransference(this.submitTransferenceData).then(() => {
      if (this.props.submitTransferenceResponse.status) {
        if (this.props.submitTransferenceResponse.status.status !== 'failure') {
          browserHistory.push({ pathname: commonUtil.getRouteByParameter(applicationRoutes.partialConfirmation, { eventID: this.submitTransferenceData.eventId }), state: { submitTransferenceDetails: this.props.submitTransferenceResponse } });
          // eslint-disable-next-line
          dataLayer.push({
            event: 'evRetire',
            amount: this.submitTransferenceData.totalAmount,
          });
        } else {
          if (this.props.submitTransferenceResponse.status.errorMessage) {
            if (this.props.submitTransferenceResponse.status.errorMessage === commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.error.message')) {
              this.confirmationButtonDisable = 'disabled';
            }
          }
          this.setState({ submitTransferenceErrorMessage: this.props.submitTransferenceResponse.status.errorMessage });
          commonUtil.goToTop();
        }
      }
    });
  }

  clearErrorMessages = () => {
    this.confirmationButtonDisable = null;
    this.setState({ submitTransferenceErrorMessage: null });
    if (channel === constChannels.WAP) {
      commonUtil.goToTop();
    }
    this.props.onBackClick();
  }

  handleHide = () => {
    this.loginModal.handleHide();
  }
  showCursorOnPassword = () => {
    this.loginModalReauthenticate.onHandleShow();
  }

  nextPage = () => { this.props.nextPage(3); }

  render() {
    const prevStep = {
      name: 'Regresar',
      type: 'button',
      value: 'Regresar',
      autoFocus: false,
      style: 'btnSecondary size-Large',
      cssStyle: {
        borderRadius: '4px',
      },
      onClickHandler: this.clearErrorMessages,
      id: 'prevStep',
    };
    const closeModal = {
      name: '×',
      type: 'button',
      value: '×',
      autoFocus: false,
      style: 'close',
      onClickHandler: this.loginModalReauthenticate ? this.loginModalReauthenticate.clearErrorMessages : null,
      id: 'closeModal',
    };
    /* const confirmButton = {
      name: 'Confirmar retiro',
      type: 'button',
      value: 'Confirmar retiro',
      autoFocus: false,
      onClickHandler: this.confirmation,
      style: 'btnPrimary size-Large',
      disabled: this.confirmationButtonDisable,
    }; */

    const confirmButton = {
      name: 'Siguiente',
      type: 'button',
      value: 'Siguiente',
      autoFocus: false,
      onClickHandler: this.nextPage,
      style: 'btnPrimary size-Large',
      disabled: this.confirmationButtonDisable,
    };

    const confirmLink = {
      id: 'nextStepLink',
      text: 'Confirmar retiro',
      children: 'Confirmar retiro',
      href: '',
      onClickHandler: this.confirmation,
      cssStyle: {
        borderRadius: '4px',
      },
      cssClass: this.confirmationButtonDisable === 'disabled' ? 'btnPrimary size-Full hiddenStyle' : 'btnPrimary size-Full closureVerification',
    };
    const RegresarLink = {
      text: 'Cancelar',
      children: 'Cancelar',
      cssClass: 'btnSecondary size-Full',
      cssStyle: {
        borderRadius: '4px',
      },
      onClickHandler: this.clearErrorMessages,
    };
    const errorAncher = {
      cssClass: 'icon-tache2',
      onClickHandler: () => { this.setState({ submitTransferenceErrorMessage: null }); },
    };

    const alertWap = {
      borderColor: '#ffffff00',
      backgroundImage: 'linear-gradient(to bottom, #FFF4D4 0%, #FFF4D4 100%)',
      width: '100%',
      borderLeft: 'thick solid #FFD457',
      color: ' #333333',
      marginTop: '2%',
    };

    const fullContainer = {
      width: channel == constChannels.WEB ? '93%' : null,
      margin: channel === constChannels.WEB ? '4%' : null,

    };

    const alerContainerWeb = {
      border: '1px solid #ADA8A8',
      borderRadius: '20px',
    };

    return (
      <div style={fullContainer}>
        {channel === constChannels.WAP ?
          <React.Fragment>
            <div className="col-xs-12 innerOptions">
              <Tagging ref={tagging => this.tagging = tagging} />
              <h2 className="subtitleSection" style={{ fontFamily: 'Roboto, sans-serif' }}>
                {commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.label2')}
              </h2>
              <p className="innerOptions"><span style={{ color: '#333333' }}>Fecha de operación &nbsp;</span>{this.props.submitTransferenceData && commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}</p>
            </div>
            {this.state.submitTransferenceErrorMessage ? <div className="col-xs-12">
              <div className="alertError">
                <i className="icon-tache2" />
                <p>{this.state.submitTransferenceErrorMessage}</p>
                <Link linkJSON={errorAncher} />
              </div>
            </div> : null}
            {!_.isEmpty(this.props.submitTransferenceData) &&
              <React.Fragment>
                <VerificationPanel
                  user={this.props.user}
                  submitTransferenceData={this.props.submitTransferenceData}
                  loadFrom="verificationForm"
                  isEmployee={this.props.isEmployee}
                />
              </React.Fragment>
            }

            <div className="col-xs-12" style={{marginBottom:"40px"}}>
              <Link linkJSON={confirmLink}>Siguiente<i className="iconRight icon-flecha_lightsvg_derecha" aria-hidden="true" data-original-title title /></Link>
            </div>

          </React.Fragment>
          :
          <React.Fragment>
            <div className="panel" style={alerContainerWeb}>
              <Tagging ref={tagging => this.tagging = tagging} />
              <div className="panel-heading row" style={{ paddingTop: 0 }}>
                <AlertTransferences />
                {
                this.props.type === 'partial' ?
                  <div style={{ paddingLeft: '20px' }}>
                    <h3 style={{ fontFamily: 'Roboto, sans-serif' }}>Verificación de retiro</h3>
                    {this.props.transferenceData && this.props.transferenceData.isEmployee && this.props.transferenceData.isEmployee !== 'true'
                    ? <p>Puedes realizar retiros parciales a monederos propios antes del cierre del evento.</p>
                  : null}
                  </div>
                : null
                }
              </div>
              <div>
                <div className="panel-body row" style={{ paddingBottom: '25px' }}>
                  <div className="col-xs-12">
                    {this.state.submitTransferenceErrorMessage ? <div className="row">
                      <div className="col-xs-6">
                        <div className="alertError">
                          <i className="icon-tache2" />
                          <p>{this.state.submitTransferenceErrorMessage}</p>
                          <Link linkJSON={errorAncher} />
                        </div>
                      </div>
                    </div> : null}
                    {!_.isEmpty(this.props.submitTransferenceData) &&
                      <React.Fragment>
                        <div className="block-verification mb0" style={{ width: '85%', margin: 'auto' }}>
                          <div className="date-verification text-right">
                            <span style={{ fontSize: '14px' }}>Fecha de operación &nbsp;</span>
                            <strong style={{ fontSize: '14px' }}>{commonUtil.formatDate(this.props.submitTransferenceData.transferDate, 'monthName')}</strong></div>
                        </div>
                        <VerificationPanel
                          user={this.props.user}
                          submitTransferenceData={this.props.submitTransferenceData}
                          loadFrom="verificationForm"
                          isEmployee={this.props.isEmployee}
                        />
                        {this.props.transferenceData && this.props.transferenceData.isEmployee && this.props.transferenceData.isEmployee !== 'true'
                        ? <p style={{ fontSize: '14px', fontWeight: '400', padding: '2% 0 0 5px' }}>
                        * En caso de depósito a monedero electrónico, podrás ver el monto abonado en las próximas horas.
                      </p>
                      : null}
                      </React.Fragment>}
                  </div>
                </div>
              </div>
            </div>
            <div className="row block-buttons">
              <div className="col-xs-6">
                <InputButton buttonAttr={prevStep} />
              </div>
              <div className="col-xs-6 text-right">
                <InputButton buttonAttr={confirmButton} />
              </div>
            </div>
          </React.Fragment>

        }
        <ModalPopover showFun={this.showCursorOnPassword} dataBackDrop="false" isModal="true" ref={loginModal => this.loginModal = loginModal} dismiss="false" dismissButton={(<div> <InputButton buttonAttr={closeModal} />{channel === 'wap' && <span id="closeModal" className="closeText">Cerrar</span>}</div>)} modalId="myModalConfirmation" header={commonUtil.getLabel(this.props.lables['Retiro Anticipado Landing Page'], 'eventTransferences.label4')}>
          <LoginModal handleHide={this.handleHide} ref={loginModalReauthenticate => this.loginModalReauthenticate = loginModalReauthenticate} callSubmitTransference={this.callSubmitTransference} lables={this.props.lables} userEmail={this.props.user.emailId} />
        </ModalPopover>
      </div>

    );
  }
}
const mapStateToProps = state => ({
  submitTransferenceResponse: state.accountSummary.submitTransference,
});
const matchDispatchToProps = dispatch => bindActionCreators({ submitTransference }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(VerificationForm);
